import { render, staticRenderFns } from "./selectGrupo_new.vue?vue&type=template&id=33cc54dc"
import script from "./selectGrupo_new.vue?vue&type=script&lang=ts"
export * from "./selectGrupo_new.vue?vue&type=script&lang=ts"
import style0 from "./selectGrupo_new.vue?vue&type=style&index=0&id=33cc54dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports